import React, { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import CustomerKitButton from '@mortee/routes/ips/customerKit/CustomerKitButton';
import Card from '@app/components/card/Card';
import SearchOvalIcon from '@app/images/search-oval.svg';
import SVG from '@app/components/SVG';
import { Regular13TransparentBlack900, Regular18TransparentBlack900 } from '@app/components/Text';

const EmptyResults: FunctionComponent = () => {
  return (
    <MainCard>
      <SVG accessibilityLabel='' image={SearchOvalIcon} width={72} height={72} />
      <MiddleText>
        <Regular18TransparentBlack900.div>No Verifications Log</Regular18TransparentBlack900.div>
        <Regular13TransparentBlack900.div>Invite your clients to verify your account</Regular13TransparentBlack900.div>
      </MiddleText>
      <CustomerKitButton />
    </MainCard>
  );
};

export default EmptyResults;

const MainCard = styled(Card)`
  height: max(270px, min(100vh - 275px, 550px));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & > *:not(:first-child) {
    margin-top: 30px;
  }
`;

const MiddleText = styled.div`
  text-align: center;

  & > *:not(:first-child) {
    margin-top: 10px;
  }
`;
